// extracted by mini-css-extract-plugin
module.exports = {"StrollerDetailRating":"xf_a bhb_a bhb_x","StrollerDetailRating__muted":"xf_b bhb_fi"};